import { createContext } from 'react'

export const SharedMediaSelectionContext = createContext({})
